import logo from '../assets/images/logo@2x.png';
import logoText from '../assets/images/logo-text@2x.png';

window.iosHref = window.location.href;
const loadHref = window.location.href;
let vue;

const config = {
  created() {
    if (!vue) {
      // console.warn('[vue-msg] not installed!');
    }
  },
  data() {
    return {
      logo: `${logo}`.replace(/^\/\//, `${window.location.protocol}//`),
      logoText: `${logoText}`.replace(/^\/\//, `${window.location.protocol}//`),
    };
  },
  methods: {
    /**
     * 添加统计代码
     */
    addCounter() {
      // const $counter = document.querySelector('.counter');
      // const $cnzz = document.createElement('script');
      // // $cnzz.src = `//s4.cnzz.com/z_stat.php?id=1278767643&web_id=1273260189&t=${new Date().getTime()}`;
      // $cnzz.src = `//v1.cnzz.com/z_stat.php?id=1278767643&online=1&t=${new Date().getTime()}`;
      // $counter.innerHTML = '';
      // $counter.id = 'cnzz_stat_icon_1278767643';
      // document.querySelector('.counter').appendChild($cnzz);
      // return new Promise((reslove, reject) => {
      //   $cnzz.onload = reslove;
      //   $cnzz.onerror = reject;
      // });
    },
    getCounter() {
      if (window._czc) {
        return _czc;
      }
      return new Promise((resolve) => {
        setInterval(() => {
          if (window._czc) {
            resolve(window._czc);
          }
        }, 5);
      });
    },

    loadStyle(src) {
      const $link = window.document.createElement('style');
      $link.rel = 'stylesheet';
      $link.type = 'text/css';
      $link.href = src;
    },
    loadScript(srcs = []) {
      return srcs.map((src) => {
        return new Promise((resolve, reject) => {
          const $script = document.createElement('script');
          $script.src = src;
          $script.onload = resolve;
          $script.onerror = reject;
          document.body.appendChild($script);
        });
      });
    },
    loadJS(src) {
      const $script = window.document.createElement('script');
      $script.src = src;
      window.document.body.appendChild($script);
      return new Promise((resolve, reject) => {
        $script.onload = resolve;
        $script.onerror = reject;
      });
    },
    // cdn替换更换
    getCdnUrl(url = '') {
      const ossDomain = 'https://cfmoto.oss-cn-hangzhou.aliyuncs.com';
      const ossTestDomain = 'https://cfmoto-test.oss-cn-hangzhou.aliyuncs.com';
      const cdnDomain = 'https://oss-cfmoto.zeehoev.com';
      const cdnTestDomain = 'https://oss-cfmoto-test.zeehoev.com';
      return url.replace('http:', 'https:').replace(ossDomain, cdnDomain).replace(ossTestDomain, cdnTestDomain);
    },
  },
  computed: {
    safeAreaInsetTop() {
      const isApp = (navigator.userAgent.toLowerCase().match(/zeeho/i) && true) || false;
      const isAndroid = (navigator.userAgent.match(/android/i) && true) || false;
      if (!isApp) return 0;
      if (isAndroid) {
        return window.zeeho.statusBarHeight();
      }
      const div = document.createElement('div');
      div.style = `height: constant(safe-area-inset-top);height: env(safe-area-inset-top);`;
      return div.clientHeight;
    },
    isSmallScreen() {
      return parseInt((window.screen.availHeight / window.screen.availWidth) * 1000) / 1000 < 2;
    },
    isLargeScreen() {
      return parseInt((window.screen.availHeight / window.screen.availWidth) * 1000) / 1000 > 2.167;
    },
    isPlusLargeScreen() {
      return parseInt((window.screen.availHeight / window.screen.availWidth) * 1000) / 1000 > 2.3;
    },
    isAndroid() {
      return (navigator.userAgent.match(/android/i) && true) || false;
    },
    isApple() {
      return (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i) && true) || false;
    },
    isHarmonyNext() {
      const ua1 = (navigator.userAgent.toLowerCase().match(/openharmony/i) && true) || false;
      const ua2 = (navigator.userAgent.toLowerCase().match(/arkweb/i) && true) || false;
      return ua1 || ua2;
    },
    isWechat() {
      return (navigator.userAgent.toLowerCase().match(/micromessenger/i) && true) || false;
    },
    isWechatWork() {
      const userAgent = navigator.userAgent.toLowerCase();
      return (/micromessenger\/[\d.]+/.test(userAgent) && /wxwork/.test(userAgent)) || false;
    },
    isDingTalk() {
      return (navigator.userAgent.toLowerCase().match(/DingTalk/i) && true) || false;
    },
    isMiniapp() {
      return (navigator.userAgent.toLowerCase().match(/miniProgram/i) && true) || false;
    },
    isQQ() {
      return (navigator.userAgent.toLowerCase().match(/qq/i) && true) || false;
    },
    isWeibo() {
      return (navigator.userAgent.toLowerCase().match(/Weibo/i) && true) || false;
    },
    isApp() {
      return (navigator.userAgent.toLowerCase().match(/zeeho/i) && true) || false;
    },
    isMobile() {
      return (navigator.userAgent.toLowerCase().match(/mobile/i) && true) || false;
    },
    isWeb() {
      return !(this.isWechat || this.isWeibo || this.isApp);
    },
    device() {
      const { width, height } = window.screen;
      const screenAspect = [
        { width: 375, height: 812, device: 'iPhoneX' },
        { width: 375, height: 667, device: 'iPhone6/iPhone6s/iPhone7/' },
      ];
      const isSameScreenAspectRatio = (deviceWidth, deviceHeight, targetWidth, targetHeight) => (deviceHeight / deviceWidth) * targetWidth === targetHeight;
      for (let i = 0; i < screenAspect.length; i++) {
        if (isSameScreenAspectRatio(width, height, screenAspect[i].width, screenAspect[i].height)) {
          return screenAspect[i].device;
        }
      }
      return 'unknown';
    },
    // ios环境微信签名url
    iosHref() {
      return loadHref;
    },
  },
  watch: {},
};
export default {
  mixin: [config],
  install(Vue) {
    vue = Vue;
    vue.prototype.addCounter = config.methods.addCounter;
    vue.prototype.getCounter = config.methods.getCounter;
    vue.prototype.safeAreaInsetTop = config.computed.safeAreaInsetTop();
    vue.prototype.isSmallScreen = config.computed.isSmallScreen();
    vue.prototype.isLargeScreen = config.computed.isLargeScreen();
    vue.prototype.isPlusLargeScreen = config.computed.isPlusLargeScreen();
    vue.prototype.isAndroid = config.computed.isAndroid();
    vue.prototype.isApple = config.computed.isApple();
    vue.prototype.isHarmonyNext = config.computed.isHarmonyNext();
    vue.prototype.isWechat = config.computed.isWechat();
    vue.prototype.isWechatWork = config.computed.isWechatWork();
    vue.prototype.isDingTalk = config.computed.isDingTalk();
    vue.prototype.isMiniapp = config.computed.isMiniapp();
    vue.isMiniapp = config.computed.isMiniapp();
    vue.prototype.isQQ = config.computed.isQQ();
    vue.prototype.isWeibo = config.computed.isWeibo();
    vue.prototype.isApp = config.computed.isApp();
    vue.isApp = config.computed.isApp();
    vue.prototype.isWeb = config.computed.isWeb();
    vue.prototype.device = config.computed.device();
    vue.prototype.iosHref = config.computed.iosHref();
    vue.prototype.options = Vue.util.mergeOptions(vue.options, config);

    vue.mixin(config);
  },
};
